import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { UpdateEmailComponent } from './update-email/update-email.component';
import { ComplaintFormRoutingModule } from './complaint-form-routing.module';
import { EditorModule } from 'primeng/editor';
import { ComplaintFlowTimelineComponent } from './complaint-flow-timeline/complaint-flow-timeline.component';
@NgModule({
  declarations: [
    UpdateEmailComponent,
    ComplaintFlowTimelineComponent
    
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    MatDialogModule,
    ComplaintFormRoutingModule,
    EditorModule
  ]
})
export class ComplaintFormModule { }
